module.exports = __webpack_public_path__ + "static/img/file_jsp.caa48c99.png";